import type { ClientLogo } from '../types/logos';

const FULL = { x1: 0, y1: 0, x2: 1, y2: 1 };

/** In file order, strongest first. File 04 was not supplied. */
export const clientLogos: ClientLogo[] = [
  {
    id: '01',
    name: 'Harvard Alumni Entrepreneurs',
    src: 'https://cdn.magicpatterns.com/uploads/wCzHGG4aBs4XHodrg214ZY/01.png',
    width: 1080,
    height: 1080,
    crop: { x1: 0.055, y1: 0.45, x2: 0.935, y2: 0.61 },
    mode: 'dark',
    slope: 2.2,
    intercept: -0.15,
  },
  {
    id: '02',
    name: 'OnePointFive',
    src: 'https://cdn.magicpatterns.com/uploads/n9EhJot2jzJERiS65AZiFC/02.png',
    width: 1080,
    height: 270,
    crop: { x1: 0.025, y1: 0.26, x2: 0.965, y2: 0.76 },
    mode: 'dark',
    slope: 3,
    intercept: -1.2,
  },
  {
    id: '03',
    name: 'grIP Venture Collective',
    src: 'https://cdn.magicpatterns.com/uploads/hLJ4AmSudeQXFU51w4BRH7/03.svg',
    width: 1725,
    height: 271,
    crop: FULL,
    mode: 'alpha',
    slope: 1,
    intercept: 0,
  },
  {
    id: '05',
    name: 'Clean Tech Open',
    src: 'https://cdn.magicpatterns.com/uploads/o3LNA1vb8yPhTnF8eVEnUT/05.jpg',
    width: 264,
    height: 144,
    crop: { x1: 0.012, y1: 0.01, x2: 0.992, y2: 0.985 },
    mode: 'dark',
    slope: 4,
    intercept: -0.2,
  },
  {
    id: '06',
    name: 'Grandstand',
    src: 'https://cdn.magicpatterns.com/uploads/j89H3kTT14bYv5QPqewEBx/06.png',
    width: 1932,
    height: 1932,
    crop: { x1: 0.095, y1: 0.41, x2: 0.907, y2: 0.585 },
    mode: 'light',
    slope: 2,
    intercept: -0.3,
  },
  {
    id: '07',
    name: 'Float House',
    src: 'https://cdn.magicpatterns.com/uploads/v5e2jK6VAp3ugsNy36tXYM/07.png',
    width: 480,
    height: 158,
    crop: FULL,
    mode: 'dark',
    slope: 3,
    intercept: -0.5,
  },
  {
    id: '08',
    name: 'Sustainable Ocean Alliance',
    src: 'https://cdn.magicpatterns.com/uploads/4xqyrf8xTq4UQL4WmeUSBu/08.png',
    width: 787,
    height: 254,
    crop: FULL,
    mode: 'dark',
    slope: 6,
    intercept: -0.25,
  },
  {
    id: '09',
    name: 'MIT Energy Conference',
    src: 'https://cdn.magicpatterns.com/uploads/uyNPtmEiXLHbmGWVrHZ5kh/09.png',
    width: 2100,
    height: 1250,
    crop: { x1: 0.07, y1: 0.295, x2: 0.928, y2: 0.705 },
    mode: 'dark',
    slope: 2.5,
    intercept: -0.2,
  },
  {
    id: '10',
    name: 'Super Serious',
    src: 'https://cdn.magicpatterns.com/uploads/pKDTb1W54NEsgQngfKxJxD/10.png',
    width: 1326,
    height: 234,
    crop: { x1: 0.055, y1: 0.235, x2: 0.943, y2: 0.735 },
    mode: 'dark',
    slope: 2,
    intercept: -0.2,
    weight: 0.9,
  },
  {
    id: '11',
    name: 'Climatebase',
    src: 'https://cdn.magicpatterns.com/uploads/c27eFvLawR63EqMcz9dZxY/11.png',
    width: 600,
    height: 600,
    crop: { x1: 0.043, y1: 0.41, x2: 0.955, y2: 0.59 },
    mode: 'dark',
    slope: 2,
    intercept: -0.2,
  },
];

export const linkedInIcon = {
  src: 'https://cdn.magicpatterns.com/uploads/eUFdgzKdfDQZEjQJFayRqr/LinkedIn_Icon.png',
};
